module.exports = __webpack_public_path__ + "img/bar.38196ed4.webp";